import app from "../../config/app";

export const getImageUrl = (url: string) => {
  return `${app.API_URL}${url}`;
};
